import { render, staticRenderFns } from "./WorkGlobalWarningDialog.vue?vue&type=template&id=4347aa53"
import script from "./WorkGlobalWarningDialog.vue?vue&type=script&lang=js"
export * from "./WorkGlobalWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports